import PropTypes from 'prop-types';
import React from 'react';

import { Link } from 'react-router-dom';

import { Button } from 'react-bootstrap/lib';

import Icon from 'components/Icon/Icon';
import Panel from 'components/Panel/Panel';

import styles from './ImproveRanking.module.scss';
import WebOnly from 'components/NativeApp/WebOnly';

const { bodyContainer, container, icon, button, footer } = styles;

const ImproveRanking = ({ message, requiredRank, profileLink }) => (
  <Panel className={`${container} box-shadow`}>
    <div className={icon}>
      <Icon color="#0777DA" icon="&#xe632;" />
    </div>
    <h1>Improve your profile</h1>
    <div className={bodyContainer}>
      {message || (
        <div>
          <p>
            To contact the client about this job, you first need to improve your
            profile.
          </p>
          <p>
            A <strong>{requiredRank}</strong> level profile score is required to
            apply.
          </p>
        </div>
      )}
      <p>
        Need help? Access our{' '}
        <a
          href="https://help.twine.net/en/article/why-cant-i-pitch-13aguem/"
          title="Help Center"
          children={'Help Center'}
        />
      </p>
    </div>
    <div className={button}>
      <Link to={profileLink}>
        <Button bsStyle="primary" className="pl pr">
          Edit your profile
        </Button>
      </Link>
    </div>
    <WebOnly>
      <p className={footer}>
        <strong>
          Or you can <Link to="/pricing/creative">upgrade to Twine Pro</Link> to
          apply on this job right now plus increase your chance of being hired.
        </strong>
      </p>
    </WebOnly>
  </Panel>
);

ImproveRanking.propTypes = {
  message: PropTypes.node,
  requiredRank: PropTypes.string,
  profileLink: PropTypes.string.isRequired,
};

export default ImproveRanking;
